export default __webpack_public_path__ + "assets/icons/header-user.4e055ad9.svg";